import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CreateAddon, UpdateAddon } from './SubscriptionSlice';

const AddonModal = ({ show, onClose, addon }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    addon_name: '',
    description: '',
    price: '',
    is_active: true
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (addon) {
      setFormData({
        addon_name: addon.addon_name || '',
        description: addon.description || '',
        price: addon.price || '',
        is_active: addon.is_active !== undefined ? addon.is_active : true
      });
    }
  }, [addon]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.addon_name.trim()) {
      newErrors.addon_name = 'Add-on name is required';
    }
    if (!formData.price || parseFloat(formData.price) < 0) {
      newErrors.price = 'Valid price is required';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      const result = addon
        ? await dispatch(UpdateAddon({ id: addon.id, data: formData }))
        : await dispatch(CreateAddon(formData));

      if (result.payload?.code === 1) {
        toast.success(addon ? 'Add-on updated successfully' : 'Add-on created successfully');
        onClose(true);
      } else {
        toast.error(result.payload?.message || 'Operation failed');
      }
    } catch (error) {
      toast.error('An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={() => onClose(false)} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{addon ? 'Edit Add-On' : 'Create Add-On'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Add-On Name *</Form.Label>
            <Form.Control
              type="text"
              name="addon_name"
              value={formData.addon_name}
              onChange={handleChange}
              isInvalid={!!errors.addon_name}
              placeholder="Enter add-on name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.addon_name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter add-on description"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Price (£) *</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="price"
              value={formData.price}
              onChange={handleChange}
              isInvalid={!!errors.price}
              placeholder="0.00"
            />
            <Form.Control.Feedback type="invalid">
              {errors.price}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              name="is_active"
              label="Active"
              checked={formData.is_active}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Saving...' : addon ? 'Update' : 'Create'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddonModal;
